<template>
    <div id="user-schedule">
        <div class="schedule-title">Raspored</div>
        <div class="app-menu">
            <span class="app-menu-control" v-on:click="toggleDay(0)">1. dan <hr></span>
            <span class="app-menu-control" v-on:click="toggleDay(1)">2. dan <hr></span>
            <span class="app-menu-personal" v-on:click="showPersonal">
                Moj raspored <hr />
                <span v-if="appliedEvents.length + favoritedEvents.length > 0" class="schedule-number-icon">{{appliedEvents.length + favoritedEvents.length}}</span>
            </span>
        </div>
        <div class="schedule-type">
            <button v-on:click="showScheduleContainer(0)">
                <img src="../../assets/app-icons/schedule/chat.svg" />
                <span>Predavanja</span>
            </button>
            <button v-on:click="showScheduleContainer(1)">
                <img src="../../assets/app-icons/schedule/laptop.svg" />
                <span>Radionice</span>
            </button>
            <button v-on:click="showScheduleContainer(2)">
                <img src="../../assets/app-icons/schedule/heart.svg" />
                <span>Campfire talks</span>
            </button>
        </div>
        <section class="app-schedule-container">
            <section class="app-schedule-item-container">
                <template v-if="shownEvents.hasOwnProperty('Lecture') && shownEvents.Lecture.length">
                    <template v-for="event in shownEvents.Lecture">
                        <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                    </template>
                </template>
            </section>

            <section class="app-schedule-item-container">
                <template v-if="shownEvents.hasOwnProperty('Workshop') && shownEvents.Workshop.length">
                    <template v-for="event in shownEvents.Workshop">
                        <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                    </template>
                </template>
            </section>

            <section class="app-schedule-item-container">
                <template v-if="shownEvents.hasOwnProperty('CampfireTalk') && shownEvents.CampfireTalk.length">
                    <template v-for="event in shownEvents.CampfireTalk">
                        <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                    </template>
                </template>
            </section>

        </section>
        <div class="my-schedule">
            <template v-if="appliedEvents.length || favoritedEvents && favoritedEvents.length">
                <div>
                    <div v-if="appliedEvents.length">
                        <h2 class="my-schedule-title">Radionice</h2>
                        <div class="day-title" v-if="appliedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[0]).length">1. dan</div>
                        <template v-for="event in appliedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[0]).sort((firstEvent, secondEvent) => new Date(firstEvent.starts) < new Date(secondEvent.starts) ? -1 : 1)">
                            <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                        </template>
                        <div class="day-title" v-if="appliedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[1]).length">2. dan</div>
                        <template v-for="event in appliedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[1]).sort((firstEvent, secondEvent) => new Date(firstEvent.starts) < new Date(secondEvent.starts) ? -1 : 1)">
                            <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                        </template>
                    </div>
                    <div v-if="favoritedEvents.length">
                        <h2 class="my-schedule-title">Predavanja i campfire</h2>
                        <div class="day-title" v-if="favoritedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[0]).length">1. dan</div>
                        <template v-for="event in favoritedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[0]).sort((firstEvent, secondEvent) => new Date(firstEvent.starts) < new Date(secondEvent.starts) ? -1 : 1)">
                            <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                        </template>
                        <div class="day-title" v-if="favoritedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[1]).length">2. dan</div>
                        <template v-for="event in favoritedEvents.filter(event => new Date(event.starts).getDate() === distinctDays[1]).sort((firstEvent, secondEvent) => new Date(firstEvent.starts) < new Date(secondEvent.starts) ? -1 : 1)">
                            <ScheduleItem v-on:click.native="openDetailsModal(event)" v-bind:event="event" v-bind:key="event.id" />
                        </template>
                    </div>
                </div>
            </template>
            <span class="no-saved" v-else>
                    Nemaš spremljenih predavanja ili radionica. Dodaj ih da dobiješ notifikacije o njihovom početku na vrijeme!
                    <button v-on:click="toggleDay(0)">DODAJ</button>
            </span>
        </div>
        <ScheduleItemDetailsModal v-if="detailsModalVisible" 
            v-on:close="detailsModalVisible = false" v-on:previous="previous" 
            v-on:next="next" v-on:save="saveOrApply" v-on:remove="removeFromFavoritedOrApplied"
            v-bind:event="eventForModal" v-bind:showPreviousNextControls="true"
            v-bind:isAppliedOrFavorited="isAppliedOrFavorited"/>
        <ScheduleItemDetailsModal v-if="otherRouteDetailsModalVisible" 
            v-on:close="otherRouteDetailsModalVisible = false" v-on:save="saveOrApply" v-on:remove="removeFromFavoritedOrApplied"
            v-bind:event="eventForOtherRouteModal" v-bind:showPreviousNextControls="false"
            v-bind:isAppliedOrFavorited="isOtherRouteAppliedOrFavorited"/>
    </div>
</template>

<script>
    import ScheduleItem from '@/components/app/ScheduleItem.vue';
    import ScheduleItemDetailsModal from '@/components/app/ScheduleItemDetailsModal.vue';
    import { groupBy } from '@/config';
    import EventBus from '@/event-bus';

    export default {
        name: 'Schedule',
        data() {
            return {
                distinctDays: [],
                events: {},
                shownEvents: {},
                hasLoaded: false,
                personalScheduleNumber: 0,
                appliedEvents: [],
                favoritedEvents: [],
                detailsModalVisible: false,
                eventForModal: {},
                otherRouteDetailsModalVisible: false,
                eventForOtherRouteModal: {}
            }
        },
        components: {
            ScheduleItem,
            ScheduleItemDetailsModal
        },
        computed : {
            isAppliedOrFavorited: function() {
                let isObjectEmpty = Object.entries(this.eventForModal).length === 0;
                if (!isObjectEmpty && 
                    (this.appliedEvents.filter(ae => ae.id === this.eventForModal.id).length || 
                    this.favoritedEvents.filter(fe => fe.id === this.eventForModal.id).length))
                        return true;
                return false;
            },
            isOtherRouteAppliedOrFavorited: function() {
                let isObjectEmpty = Object.entries(this.eventForOtherRouteModal).length === 0;
                if (!isObjectEmpty && 
                    (this.appliedEvents.filter(ae => ae.id === this.eventForOtherRouteModal.id).length || 
                    this.favoritedEvents.filter(fe => fe.id === this.eventForOtherRouteModal.id).length))
                        return true;
                return false;
            }
        },
        methods: {
            toggleDay: function(dayNumber) {
                let controls = document.querySelectorAll('.app-menu .app-menu-control');

                for(let control of controls)
                    control.classList.remove('active');

                document.querySelector('.app-menu-personal').classList.remove('active');

                controls[dayNumber].classList.add('active');

                document.querySelector('.my-schedule').style.display = 'none';
                document.querySelector('.schedule-type').style.display = 'flex';
                document.querySelector('.app-schedule-container').style.display = 'block';

                this.filterShownEvents(dayNumber);
            },
            filterShownEvents: function(dayNumber) {
                for(let category in this.shownEvents)
                    this.shownEvents[category] = 
                        this.events[category].filter(event => new Date(event.starts).getDate() === this.distinctDays[dayNumber]);
            },
            showScheduleContainer: function(indexOfContainerToShow) {
                let scheduleItemContainers = document.querySelectorAll('.app-schedule-item-container');

                for (let container of scheduleItemContainers)
                    container.classList.remove('active');

                scheduleItemContainers[indexOfContainerToShow].classList.add('active');

                let scheduleButtons = document.querySelectorAll('.schedule-type button');

                for(let button of scheduleButtons)
                    button.classList.remove('active');
                
                scheduleButtons[indexOfContainerToShow].classList.add('active');
            },
            showPersonal: function() {
                let controls = document.querySelectorAll('.app-menu .app-menu-control');

                for(let control of controls)
                    control.classList.remove('active');

                document.querySelector('.app-menu-personal').classList.add('active');
                document.querySelector('.my-schedule').style.display = 'block';
                document.querySelector('.schedule-type').style.display = 'none';
                document.querySelector('.app-schedule-container').style.display = 'none';
            },
            openDetailsModal: function(event) {
                if(event.name === 'Pauza' || event.name === 'Ručak')
                    return;
                this.eventForModal = event;
                this.detailsModalVisible = true;
            },
            previous: function(type) {
                let shownEventsOfThatType = this.shownEvents[type];
                let indexOfEventForModal = shownEventsOfThatType.indexOf(this.eventForModal);
                if(indexOfEventForModal === 0)
                {
                    let previousEvent = shownEventsOfThatType[shownEventsOfThatType.length - 1];
                    if(previousEvent.name === 'Ručak' || previousEvent.name === 'Pauza')
                        this.eventForModal = shownEventsOfThatType[shownEventsOfThatType.length - 2];
                    else
                        this.eventForModal = previousEvent;
                }
                else
                {
                    let previousEvent = shownEventsOfThatType[indexOfEventForModal - 1];
                    if(previousEvent.name === 'Ručak' || previousEvent.name === 'Pauza')
                        this.eventForModal = shownEventsOfThatType[indexOfEventForModal - 2];
                    else
                        this.eventForModal = previousEvent;
                }
            },
            next: function(type) {
                let shownEventsOfThatType = this.shownEvents[type]
                let indexOfEventForModal = shownEventsOfThatType.indexOf(this.eventForModal);
                if(indexOfEventForModal === shownEventsOfThatType.length - 1)
                {
                    let nextEvent = shownEventsOfThatType[0];
                    if(nextEvent.name === 'Ručak' || nextEvent.name === 'Pauza')
                        this.eventForModal = shownEventsOfThatType[1];
                    else
                        this.eventForModal = nextEvent;
                }
                else
                {
                    let nextEvent = shownEventsOfThatType[indexOfEventForModal + 1];
                    if(nextEvent.name === 'Ručak' || nextEvent.name === 'Pauza')
                        this.eventForModal = shownEventsOfThatType[indexOfEventForModal + 2];
                    else
                        this.eventForModal = nextEvent;
                }
            },
            saveOrApply: function(event) {
                if(event.type === 'Workshop')
                {
                    this.$axios.post(`${this.$API_URL}/user/apply`, {
                        eventId: event.id    
                    }).then(() => {
                        alert('Prijava na radionicu uspješna!');
                        this.appliedEvents.push(event);
                        EventBus.$emit('increment-navigation-number');
                    }).catch(() => {
                        alert('Prijava na događaj neuspješna. Nemaš dopuštenje ili je događaj već pun.');
                        return;
                    });
                }
                else
                {
                    this.favoritedEvents.push(event);
                    this.$axios.post(`${this.$API_URL}/user/grant-notification-achievement`).then(() => {});
                    localStorage.setItem('favoritedEvents', JSON.stringify(this.favoritedEvents));
                    EventBus.$emit('increment-navigation-number');
                }
                this.detailsModalVisible = false;
            },
            removeFromFavoritedOrApplied: function(event) {
                if(event.type === 'Workshop')
                {
                    this.$axios.post(`${this.$API_URL}/user/remove-apply`, {
                        eventId: event.id    
                    }).then(() => {
                        alert('Odjava s događaja uspješna! Žao nam je što ipak nećeš doći :(');
                        this.appliedEvents.splice(this.appliedEvents.findIndex(ev => ev.id === event.id), 1);
                        EventBus.$emit('decrement-navigation-number');
                    }).catch(() => {
                        alert('Odjava s događaja neuspješna. Molimo te pokušaj opet.');
                        return;
                    });
                }
                else
                {
                    this.favoritedEvents.splice(this.favoritedEvents.findIndex(ev => ev.id === event.id), 1);
                    localStorage.setItem('favoritedEvents', JSON.stringify(this.favoritedEvents));
                    EventBus.$emit('decrement-navigation-number');
                }
                this.detailsModalVisible = false;
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/events/events-for-schedule`).then(response => {
                this.distinctDays = 
                    [...new Set(response.data.map(event => new Date(event.starts).getDate()))].sort();
                this.events = groupBy(response.data, 'type');
                this.shownEvents = Object.assign({}, this.events);
                
                let eventTypeToShow = this.$route.params.shown;

                switch(eventTypeToShow)
                {
                    case 'workshop':
                        this.showScheduleContainer(1);
                        break;
                    case 'campfire':
                        this.showScheduleContainer(2);
                        break;
                    case 'lecture':
                    default:
                        this.showScheduleContainer(0);
                        break;
                }
                this.toggleDay(0);

                let idForPopup = this.$route.params.popupId;
                let typeForPopup = this.$route.params.type;
                if(idForPopup && typeForPopup)
                {
                    let eventsOfThatType = this.events[typeForPopup];
                    this.eventForOtherRouteModal = eventsOfThatType[eventsOfThatType.findIndex(ev => ev.id === idForPopup)];
                    this.otherRouteDetailsModalVisible = true;
                }

                this.hasLoaded = true;
            });

            this.$axios.get(`${this.$API_URL}/user/applied-workshops`).then(response => {
                this.appliedEvents = response.data;
                try 
                {
                    let parsedEvents = JSON.parse(localStorage.getItem('favoritedEvents'));
                    this.favoritedEvents = [...parsedEvents];
                } 
                catch 
                {
                    this.favoritedEvents = [];
                }
            });
        }
    }
</script>

<style scoped>
#user-schedule {
    margin-top: 20px;
    padding-left: 20px;
}

.schedule-title {
    font-size: 24px;
    font-weight: 800;
    line-height: 29px;
}

.app-schedule-item-container,
.my-schedule {
    display: none;
}

.app-schedule-item-container.active,
.my-schedule.active {
    display: block;
}

.my-schedule {
    margin-top: 20px;
}

.app-menu {
    display: flex;
    margin-top: 25px;
    height: 35px;
}

.app-menu span {
    font-size: 18px;
    line-height: 20px;
    opacity: 0.35;
    margin-right: 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
}

.app-menu span.active {
    font-weight: bold;
    line-height: 21px;
    opacity: 1;
}

.app-menu span hr {
    display: none;
    border: none;
    width: 20px;
    height: 3px;
    margin-top: 2px;
    opacity: 1;
    background-color: #30cec1;
    border-radius: 10px;
}

.app-menu span:hover {
    cursor: pointer;
}

.app-menu span.active hr {
    display: block;
}

.schedule-type {
    margin-top: 10px;
    display: flex;
    margin-left: -10px;
}

.schedule-type button {
    flex: 0 0 95px;
    border-radius: 6px;
    box-shadow: 0 2px 20px 0 rgba(0,0,0,0.1);
    border: none;
    background-color: white;
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 12px;
    padding: 5px 0 5px 4px;
}

.schedule-type button:hover {
    cursor: pointer;
}

.schedule-type button.active {
    background-color: #30cec1;
    color: white;
}

.schedule-type button img {
    margin-bottom: 2px;
}

.schedule-type button.active img {
    filter: invert(100%);
}

.app-menu-personal {
    position: relative;
}

.app-menu .schedule-number-icon {
    position: absolute;
    right: -35px;
    bottom: 3px;
    background-color: #30cec1;
    font-size: 10px;
    color: white;
    border-radius: 100%;
    padding: 0 6px;
    opacity: 1;
}

.app-schedule-container {
    margin-top: 30px;
}

.no-saved {
    display: inline-block;
    width: 100%;
    font-size: 24px;
    opacity: 0.8;
    font-weight: 700;
    text-align: center;
    margin-left: -10px;
    margin-top: 100px;
}

.no-saved button {
    border: none;
    margin-top: 15px;
    background-color: #30cec1;
    color: white;
    font-size: 16px;
    padding: 7px 14px;
    border-radius: 5px;
    font-weight: 700;
}

.no-saved button:hover {
    cursor: pointer;
}

.my-schedule-title {
    font-size: 16px;
}

.day-title {
    margin-bottom: 10px;
}
</style>